import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';

import { Account } from '@libs/src/models/account.model';
import { GroupHiddenCustomSegment } from '@libs/src/models/group.model';
import { isAnyAdmin } from '@main-client/src/app/user/user.helpers';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-group-hidden-custom-segment-header',
  templateUrl: './group-hidden-custom-segment-header.component.html',
})
export class GroupHiddenCustomSegmentHeaderComponent implements OnInit {
  @Input({ required: true }) customSegment: GroupHiddenCustomSegment;
  @Input({ required: true }) user: Account;
  userIsAnyAdmin = false;

  ngOnInit() {
    this.userIsAnyAdmin = isAnyAdmin(this.user);
  }
}
